import { escapeRegExp } from 'lodash-es'
import { demoParticipantLabel } from '#src/demo-mode/demoNumbers.ts'

// Real names that demo mode already hid, so the same names can be replaced in
// free text (AI chat replies, reference labels). A single given or family name
// shorter than 4 letters is skipped: it matches too many ordinary words.
const MIN_PART_LENGTH = 4
const idByName = new Map<string, string>()
let pattern: RegExp | undefined

export function recordHiddenName(
  participantId: string,
  names: (string | undefined)[]
): void {
  for (const name of names) {
    const trimmed = name?.trim()
    if (
      !trimmed ||
      trimmed.length < MIN_PART_LENGTH ||
      idByName.get(trimmed) === participantId
    ) {
      continue
    }
    idByName.set(trimmed, participantId)
    pattern = undefined
  }
}

export function scrubKnownNames(text: string): string {
  if (idByName.size === 0) {
    return text
  }
  // Longest first, so "Pham, Charles" wins over "Charles".
  // Unicode letter boundaries: `\b` only knows ASCII word characters, so it
  // misses names such as "Élodie" or "歐陽美華".
  pattern ??= new RegExp(
    `(?<![\\p{L}\\p{N}])(${[...idByName.keys()]
      .sort((a, b) => b.length - a.length)
      .map(escapeRegExp)
      .join('|')})(?![\\p{L}\\p{N}])`,
    'gu'
  )
  return text.replace(pattern, (match) => {
    const participantId = idByName.get(match)
    return participantId ? demoParticipantLabel(participantId) : match
  })
}

export function resetHiddenNames(): void {
  idByName.clear()
  pattern = undefined
}
